import React, { useState, useEffect, useRef } from 'react';
import { Item } from '../item';
import cmsUtils from '../../utils/cmsUtils';
import utils from '../../../utils';
import Slider from "react-slick";
import './style.scss';
import { SiteLink } from '../../../components';
import { useMediaQuery } from 'react-responsive';

export function FullSizeBannerPanel(props) {
  const item = props.item;
  const subItems = item.items || [];
  const cmsOption = props.cmsOption || {};
  const isMobile = utils.site.isMobile();
  const isNotDesktop = useMediaQuery({ maxWidth: 700 });

  const DESIGN_WIDTH = 2560;
  const DESIGN_DOTS_BOTTOM = 170; // 在设计稿中的底部距离(px)
  const DESIGN_DOTS_SIZE = 20;

  const dotsBottom = isMobile
    ? "15%"  // Mobile
    : `${(DESIGN_DOTS_BOTTOM / DESIGN_WIDTH) * 100}vw`; // Laptop

  const timer = cmsUtils.payload(item, 'Timer') || 5;
  const anchorPoint = cmsUtils.payload(item, 'AnchorPoint') || '#';

  const [activeIndex, setActiveIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const sliderRef = useRef(null);
  const progressInterval = useRef(null);

  const slides = subItems.map((subItem, index) => (
    <div key={`${subItem.itemId}-${index}`} className="full-size-banner-slide">
      <Item
        item={subItem}
        cmsOption={cmsOption}
        activeIndex={activeIndex}
        itemIndex={index}
      />
    </div>
  ));

  useEffect(() => {
    // Clear any existing interval
    if (progressInterval.current) {
      clearInterval(progressInterval.current);
    }

    // Start new progress animation
    const startTime = Date.now();
    const duration = timer * 1000;

    progressInterval.current = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const newProgress = Math.min((elapsed / duration) * 100, 100);
      setProgress(newProgress);

      if (newProgress >= 100) {
        clearInterval(progressInterval.current);
      }
    }, 50); // Update progress every 50ms for smooth animation

    return () => {
      if (progressInterval.current) {
        clearInterval(progressInterval.current);
      }
    };
  }, [activeIndex, timer]);

  var settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    autoplaySpeed: timer * 1000,
    fade: true,
    autoplay: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
    beforeChange: (current, next) => {
      setActiveIndex(next);
      setProgress(0);
    },
    afterChange: (current) => {
      setActiveIndex(current); // 确保状态同步
    },
    customPaging: (i) => (
      <div
        className="custom-dot"
        onClick={() => {
          if (sliderRef.current) {
            sliderRef.current.slickGoTo(i);
            // setActiveIndex(i);
            // setProgress(0);
          }
        }}
      >
        <div
          className="progress-ring"
          style={{
            background: i === activeIndex
              ? `conic-gradient(white ${progress}%, transparent ${progress}%)`
              : "transparent",
          }}
        ></div>
      </div>
    ),
    appendDots: (dots) => (
      <div
        style={{
          position: "absolute",
          // bottom: getDotsPosition(),
          bottom: isMobile ? "0%" : dotsBottom,
          ...(isMobile ? { right: "0%" } : { left: "50%" }),
          transform: isMobile ? "translate(-10%, -50%)" : "translate(-50%, -50%)",
        }}
        className="custom-dots-container"
      >
        <ul style={{
          display: "flex",
          gap: isMobile ? "6px" : "15px",
          paddingLeft: "0",
        }}>
          {dots}
        </ul>
      </div>
    )
  };

  // console.log("isMobile:", isMobile)

  const cssClass = utils.classNames('cms_item', 'bannerPanel', 'full-size-container', item.cssClass || item.anchorName || '');

  return (
    <section className='full-size-section'>
      <div className={cssClass} data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName}>
        <
          // @ts-ignore
          Slider {...settings} ref={sliderRef}>
          {slides}
        </Slider>
      </div>
      {!isMobile && (
        <SiteLink to={anchorPoint} className="anchor-point">
          <img src='/assets/icons/down-arrow.png' />
        </SiteLink>
      )}
    </section>
  );
}